import { HttpClient } from "@angular/common/http";
import { NgcCookieConsentConfig } from "ngx-cookieconsent";

export function cookieConfigFactory(http: HttpClient, document: Document, config: NgcCookieConsentConfig) {
    console.log(document.domain);
    return () => config.cookie.domain = document.domain;
}